export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["deDE"] = "de-DE";
    LanguageCode["deAT"] = "de-AT";
    LanguageCode["deCH"] = "de-CH";
    LanguageCode["enEN"] = "en-EN";
    LanguageCode["enFI"] = "en-FI";
    LanguageCode["enUK"] = "en-UK";
    LanguageCode["enGB"] = "en-GB";
    LanguageCode["frFR"] = "fr-FR";
    LanguageCode["frBE"] = "fr-BE";
    LanguageCode["frCH"] = "fr-CH";
    LanguageCode["itIT"] = "it-IT";
    LanguageCode["nlNL"] = "nl-NL";
    LanguageCode["nlBE"] = "nl-BE";
    LanguageCode["plPL"] = "pl-PL";
    LanguageCode["esES"] = "es-ES";
    LanguageCode["csCZ"] = "cs-CZ";
    LanguageCode["svSE"] = "sv-SE";
    LanguageCode["daDK"] = "da-DK";
    LanguageCode["fiFI"] = "fi-FI";
    LanguageCode["noNO"] = "no-NO";
    LanguageCode["ltLT"] = "lt-LT";
    LanguageCode["skSK"] = "sk-SK";
    LanguageCode["ptPT"] = "pt-PT";
    LanguageCode["roRO"] = "ro-RO";
    LanguageCode["etEE"] = "et-EE";
    LanguageCode["lvLV"] = "lv-LV";
    LanguageCode["slSI"] = "sl-SI";
    LanguageCode["hrHR"] = "hr-HR";
    LanguageCode["huHU"] = "hu-HU";
    LanguageCode["frLU"] = "fr-LU";
    LanguageCode["deLU"] = "de-LU";
})(LanguageCode || (LanguageCode = {}));
/**
 * A currency code in the ISO 4217 format.
 *
 * @see [ISO 4217 - Wikipedia](https://en.wikipedia.org/wiki/ISO_4217#Active_codes)
 */
export var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["CHF"] = "CHF";
    Currency["GBP"] = "GBP";
    Currency["PLN"] = "PLN";
    Currency["CZK"] = "CZK";
    Currency["SEK"] = "SEK";
    Currency["DKK"] = "DKK";
    Currency["NOK"] = "NOK";
    Currency["RON"] = "LEI";
    Currency["HUF"] = "HUF";
})(Currency || (Currency = {}));
//# sourceMappingURL=types.js.map